/**
 * Gửi lại GET bị Gateway trả `429`.
 *
 * Gateway trả 429 kèm `Retry-After` khi tenant đang có quá nhiều request **cùng lúc** vào một module
 * (`TENANT_CONCURRENCY_EXCEEDED`, ADR-0011 mục 4.6) hoặc vượt ngưỡng theo giây (`RATE_LIMITED`, ADR-0005).
 * Gateway không xếp hàng hộ, mà gói Trial/Standard chỉ cho 3 GET đồng thời mỗi module — riêng màn chi tiết
 * hồ sơ thẩm định mở ra đã bắn 4. Request bị chặn ngay ở Gateway, chưa tới module, nên gửi lại một GET là an
 * toàn (ADR-0011 mục 5: "thao tác đọc thì thử lại an toàn"). Lệnh ghi không gửi lại: để người dùng tự bấm.
 */

/** Số lần gửi lại tối đa; quá số này thì báo lỗi như thường. */
export const SO_LAN_THU_429 = 2;

/** `Retry-After` dài hơn mức này thì không chờ: người dùng nên thấy lỗi, không phải màn đứng im. */
export const CHO_429_TOI_DA_MS = 3_000;

/** Khoảng ngẫu nhiên cộng thêm, để các request cùng bị chặn không quay lại đúng một lúc rồi lại chặn nhau. */
const LECH_TOI_DA_MS = 500;

/** Số mili giây cần chờ trước khi gửi lại, hoặc `undefined` nếu không gửi lại. */
export function choTruocKhiThuLai(
  status: number,
  retryAfter: string | null,
  ngauNhien: () => number = Math.random,
): number | undefined {
  if (status !== 429 || retryAfter === null || retryAfter.trim() === '') return undefined;
  // Chỉ nhận dạng số giây. Dạng ngày HTTP Gateway không dùng; gặp thì coi như không có.
  const giay = Number(retryAfter);
  if (!Number.isFinite(giay) || giay < 0) return undefined;
  const ms = giay * 1000;
  if (ms > CHO_429_TOI_DA_MS) return undefined;
  return ms + ngauNhien() * LECH_TOI_DA_MS;
}
